import {
  EditInput,
  MomentLinkCell,
  ValueCell,
} from "../SimpleComponentVisualization";
import { CollapseChevron, KeyCell } from "./KVStoreCells";
import { NodeAdder } from "./useNodeAdding";

// The inline key/value pair for a node being added — under a parent, or at
// the top level. Tab moves between the pair without leaving the row. Tabbing
// backwards out of the key or forwards out of the value commits the edit.
const AddNodeRow = ({
  depth,
  adder,
  compact,
}: {
  depth: number;
  adder: NodeAdder;
  compact: boolean;
}) => {
  const { adding, rowRef, changeAdding, applyAdding } = adder;
  if (!adding) {
    return null;
  }
  return (
    <tr
      ref={rowRef as React.RefObject<HTMLTableRowElement>}
      data-testid="kv-store-add-row"
    >
      <KeyCell $depth={depth}>
        <div className="d-flex">
          <CollapseChevron visible={false} className="bi-chevron-down" />
          <EditInput
            autoFocus
            value={adding.key}
            placeholder="key"
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              changeAdding({ key: event.target.value })
            }
            onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
              if (event.key === "Tab" && event.shiftKey) {
                applyAdding();
              }
            }}
            data-testid="kv-store-add-key-input"
          />
        </div>
      </KeyCell>
      <ValueCell $compactView={compact}>
        <EditInput
          value={adding.value}
          placeholder="value"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            changeAdding({ value: event.target.value })
          }
          onKeyDown={(event: React.KeyboardEvent<HTMLInputElement>) => {
            if (event.key === "Tab" && !event.shiftKey) {
              applyAdding();
            }
          }}
          data-testid="kv-store-add-value-input"
        />
      </ValueCell>
      <MomentLinkCell />
    </tr>
  );
};

export default AddNodeRow;
